/**
 * Configuration de la compression d'images avec browser-image-compression
 * 
 * Cette configuration offre un équilibre optimal entre qualité et taille de fichier
 * pour les images de trading (graphiques, screenshots, etc.)
 */

import type { Options } from 'browser-image-compression';

/**
 * Profils de compression prédéfinis
 */
export const COMPRESSION_PROFILES = {
  /**
   * HAUTE QUALITÉ - Pour les graphiques de trading et screenshots détaillés
   * Recommandé pour: Graphiques TradingView, analyses techniques
   * Réduction attendue: 60-70%
   */
  highQuality: {
    maxSizeMB: 2,                    // Max 2MB
    maxWidthOrHeight: 2048,          // Max 2048px (très haute résolution)
    useWebWorker: true,              // Performance optimale
    initialQuality: 0.90,            // 90% qualité
    alwaysKeepResolution: false,
    fileType: undefined,             // Auto-détection (garde PNG si transparence)
  } as Options,

  /**
   * QUALITÉ STANDARD - Pour les photos et images générales
   * Recommandé pour: Photos, captures d'écran générales
   * Réduction attendue: 70-80%
   */
  standard: {
    maxSizeMB: 1.5,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
    initialQuality: 0.85,
    alwaysKeepResolution: false,
    fileType: undefined,
  } as Options,

  /**
   * OPTIMISÉE - Pour un équilibre taille/qualité
   * Recommandé pour: Uploads multiples, connexions lentes
   * Réduction attendue: 80-90%
   */
  optimized: {
    maxSizeMB: 1,
    maxWidthOrHeight: 1600,
    useWebWorker: true,
    initialQuality: 0.80,
    alwaysKeepResolution: false,
    fileType: 'image/jpeg',          // Force JPEG pour meilleure compression
  } as Options,
};

/**
 * Configuration par défaut utilisée pour tous les uploads
 * Actuellement: HIGH QUALITY pour préserver les détails des graphiques
 */
export const DEFAULT_COMPRESSION_CONFIG = COMPRESSION_PROFILES.highQuality;

/**
 * Seuil de taille en dessous duquel la compression n'est pas appliquée
 * (évite de compresser des images déjà optimisées)
 */
export const MIN_SIZE_FOR_COMPRESSION_KB = 100; // 100KB

/**
 * Formats d'image qui supportent la transparence
 * Ces formats seront préservés si possible
 */
export const TRANSPARENT_FORMATS = ['image/png', 'image/webp'];





